export default __webpack_public_path__ + "static/media/Roboto-Light.19a99746.woff";